import React, {useState, useEffect, Fragment } from 'react';
import { 
         Button,
         Checkbox,
         Grid,     
         CircularProgress,
         LinearProgress,
         Paper,
         TextField,
         withWidth
        } from '@material-ui/core';
import { 
            CheckBox as CheckBoxIcon,
            CheckBoxOutlineBlank as CheckBoxOutlineBlankIcon,
            Clear as ClearIcon,
            Send as SendIcon,
        } from '@material-ui/icons';
import {
    CommentOutlined as CommentOutlinedIcon,
    MailOutlined as MailOutlinedIcon,
    WhatsAppOutlined as WhatsAppOutlinedIcon,
} from '@ant-design/icons';
import { Autocomplete } from '@material-ui/lab';
import { useAuth } from "../Auth";
import Swal from 'sweetalert2';
import { Switch as SwitchAntd, Tooltip as TooltipAntd } from 'antd';

function Notificaciones({width:widthWin}){
    console.log(widthWin)
    const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
    const checkedIcon = <CheckBoxIcon fontSize="small" />;
    const { authTokens } = useAuth(); 
    const [ Datos, setDatos] = useState({TEXTO:'', isSms:false, isMail:false, isWhatsapp:false});
    const [ dataZona, setDataZona ] = useState([]);
    const [ zonaSelected, setZonaSelected ] = useState([]);
    const [ isProcessing, setProcessing ] = useState(false);
    const [ getServicio, setServicio ] = useState(true);
    const [ getArrClientes, setArrClientes ] = useState([]);
    const [ getClientes, setClientes ] = useState([]);
    const [ getBackupClientes, setBackupClientes ] = useState([]);
    const [ zonaCliente, setZonaCliente ] = useState('');
    const [ getNombres, setNombres ] = useState(true);

    
    /************************************************************************/
    useEffect(
        ()=>{
            async function ReqInfo() {
                const dataZonas = await fetch('/api/Zonas');
                const resultZonas = await dataZonas.json();
                const dataClientes = await fetch('/api/Clientes');
                const resultClientes = await dataClientes.json();
                setBackupClientes(resultClientes)
                if(authTokens.Type === 'ADMINISTRADOR'){
                    setDataZona(resultZonas);
                }else{              
                    const ZonasArr = authTokens.Zonas.map(valZon=> valZon.Zona);
                    const arrFilZona = resultZonas.filter(value=> ZonasArr.includes(value.Zona.toString()))
                    setDataZona(arrFilZona);
                } 
            };
        
            ReqInfo();
        },[] // eslint-disable-line react-hooks/exhaustive-deps
    );


    const handleDatos = (e) =>{ setDatos({...Datos, [e.target.id]: e.target.value}) };


    const handleClearZona = ()=>{
        setZonaSelected([]);
    };

    const handleSelectZona = (valZ)=>{
        setZonaSelected(valZ);
    };

    const handleClear = ()=>{
        setZonaSelected([]);
        setDatos({TEXTO:'', isSms:false, isMail:false, isWhatsapp:false});
        setServicio(true);
        setClientes([]);
        setZonaCliente('');
        setNombres(true);
    };

    const handleSendZona = ()=>{
        if(dataZona.length === 0){
            Swal.fire({
                title:'SELECCIONE UNA ZONA POR LO MENOS',
                icon:'error',
                showDenyButton: false,
                showCancelButton: false,
                confirmButtonColor:'#005596',
                width:500
            })
        }else{
            Swal.fire({
                title:'ESTA CORRECTA LA INFORMACION?',
                icon:'info',
                confirmButtonText:'SI',
                denyButtonText:'NO',
                showDenyButton: true,
                showCancelButton: true,
                confirmButtonColor:'#005596',
                width:600
            }).then(resServ=>{
                if(resServ.isConfirmed){
                    setProcessing(true)
                    const objeto = {...Datos};
                        objeto.Zonas = zonaSelected;
                    fetch('/api/SinietroByZona',{
                        method:'POST',
                        body: JSON.stringify(objeto),
                        headers:{'Content-Type': 'application/json'}
                    }) 
                    .then(response=> response.json())
                    .then((result) =>{
                        Swal.fire({
                            title:result.message ? result.message : result.status,
                            icon:result.message ? 'success' : 'error',
                            showDenyButton: false,
                            showCancelButton: false,
                            confirmButtonColor:'#005596',
                            width:500
                        });
                        setProcessing(false)
                    })
                }
            })
        }
    };

    const handlePreSend = ()=>{
        if(getServicio){
            handleSendZona();
        }else{
            handleSendClient();
        }
    };

    const handleSms = (checked)=>{
        setDatos({...Datos, isSms:checked});
    };

    const handleMail = (checked)=>{
        setDatos({...Datos, isMail:checked});
    };

    const handleWhatsapp = (checked)=>{
        setDatos({...Datos, isWhatsapp:checked});
    };

    const handleTipoServicio = (checked)=>{
        setServicio(checked);
    };

    const handleSendClient = ()=>{
        if(getArrClientes.length === 0){
            Swal.fire({
                title:'SELECCIONE UN CLIENTE POR LO MENOS',
                icon:'error',
                showDenyButton: false,
                showCancelButton: false,
                confirmButtonColor:'#005596',
                width:500
            })
        }else{
            Swal.fire({
                title:'ESTA CORRECTA LA INFORMACION?',
                icon:'info',
                confirmButtonText:'SI',
                denyButtonText:'NO',
                showDenyButton: true,
                showCancelButton: true,
                confirmButtonColor:'#005596',
                width:600
            }).then(resServ=>{
                if(resServ.isConfirmed){
                    setProcessing(true)
                    const objeto = {...Datos};
                        objeto.Zona = zonaCliente;
                        objeto.Clientes = getArrClientes;
                        objeto.Empresa = authTokens.Empresa;
                    fetch('/api/SinietroByCliente',{
                        method:'POST',
                        body: JSON.stringify(objeto),
                        headers:{'Content-Type': 'application/json'}
                    }) 
                    .then(response=> response.json())
                    .then((result) =>{
                        Swal.fire({
                            title:result.message ? result.message : result.status,
                            icon:result.message ? 'success' : 'error',
                            showDenyButton: false,
                            showCancelButton: false,
                            confirmButtonColor:'#005596',
                            width:500
                        });
                        setProcessing(false)
                    })
                }
            })
        }
    };

    const handleSelectZona2 = (e, value, reason)=>{
        if(reason ===  'clear'){
            setZonaCliente('');
            setClientes([]);
        }else{
            setZonaCliente(value);
            const arrClientes = getBackupClientes.filter(el=> el.Zona.toString().trim() === value);
            setClientes(arrClientes)
        }
    };

    const handleSelectClient = (e, value, reason)=>{
        if(reason ===  'clear'){
            setArrClientes([]);
        }else{
            setArrClientes(value);
        }
    };

    const handleSwitchNombres = (checked)=>{ setNombres(checked); };


    return(
        <Fragment>
            <Grid container spacing={1} style={{padding:10, width:'100%', height:'90vh'}} justifyContent='center' alignItems='flex-start'>
                <Grid item xl={5} lg={5} md={8} sm={12} xs={12} >
                    <Paper elevation={3} style={{padding:15, width:'100%', minHeight:300}}>
                        <Grid container spacing={2} justifyContent='center'>
                            <Grid item xs={12} style={{height:5}}>
                                {isProcessing &&  <LinearProgress color='secondary' /> }
                            </Grid>
                            <Grid item xs={12} style={{alignSelf:'center'}}>
                                <Grid container spacing={2} justifyContent='center'>
                                    <Grid item>
                                        <b>
                                            SELECCIONE COMO DESEA TRABAJAR:
                                        </b>
                                    </Grid>
                                    <Grid item>
                                        <TooltipAntd title="COMO DESEA TRABAJAR? " color='blue' >
                                            <SwitchAntd size='large' checkedChildren="ZONAS" unCheckedChildren="CLIENTES" checked={getServicio} onChange={handleTipoServicio} />
                                        </TooltipAntd>
                                    </Grid>
                                </Grid>
                            </Grid>
                            {
                                getServicio ?
                                <Fragment>
                                    <Grid item xs={12}>
                                        <Autocomplete
                                            id="Zona"
                                            multiple
                                            options={dataZona.map(value=>value.Zona)}
                                            value={zonaSelected || ''}                              
                                            renderInput={(params) => <TextField {...params} label="Zonas" variant="outlined" size='small' fullWidth color='primary'/>}
                                            onChange={(e,value, reason)=>{
                                                if(reason ===  'clear'){
                                                    handleClearZona()
                                                }else{
                                                    handleSelectZona(value);
                                                }
                                            }} 
                                            renderOption={(option, { selected }) => (
                                                <React.Fragment style={{fontSize:10}}>
                                                    <Checkbox
                                                        icon={icon}
                                                        checkedIcon={checkedIcon}
                                                        style={{ marginRight: 8 }}
                                                        checked={selected}
                                                    />
                                                {option}
                                                </React.Fragment>
                                            )}
                                        />
                                    </Grid>   
                                </Fragment>:
                                <Fragment>
                                    <Grid item xs={12}>
                                        <Grid container spacing={2}>
                                            <Grid item xs={8}>
                                                <Autocomplete
                                                    id="Zona"
                                                    options={dataZona.map(value=>value.Zona)}
                                                    value={zonaCliente || ''}                              
                                                    renderInput={(params) => <TextField {...params} label="Zona" variant="outlined" size='small' fullWidth color='primary'/>}
                                                    onChange={handleSelectZona2} 
                                                />
                                            </Grid>
                                            <Grid item xs={4} style={{display:'grid', placeContent:'center'}}>
                                                <TooltipAntd title="NOMBRES O CI" color='blue' >
                                                    <SwitchAntd checkedChildren="NOMBRES" unCheckedChildren="CI" checked={getNombres} onChange={handleSwitchNombres} />
                                                </TooltipAntd>
                                            </Grid> 
                                        </Grid>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Autocomplete
                                            id="Cliente"
                                            multiple
                                            getOptionLabel={(option)=> getNombres ? option.Nombres : option.CI}
                                            options={getClientes}
                                            value={getArrClientes || ''}                              
                                            renderInput={(params) => <TextField {...params} label={getNombres ? "Nombres" : 'CI'} variant="outlined" size='small' fullWidth color='primary'/>}
                                            onChange={handleSelectClient} 
                                            renderOption={(option, { selected }) => (
                                                <React.Fragment style={{fontSize:10}}>
                                                    <Checkbox
                                                        icon={icon}
                                                        checkedIcon={checkedIcon}
                                                        style={{ marginRight: 8 }}
                                                        checked={selected}
                                                    />
                                                {getNombres ? option.Nombres : option.CI}
                                                </React.Fragment>
                                            )}
                                        />
                                    </Grid> 
                                </Fragment>
                            }
                            <Grid item xs={12} style={{maxHeight:widthWin === 'xs' ? 310 : 500, overflow:'auto'}}>                                                
                                <TextField 
                                    id='TEXTO'
                                    fullWidth
                                    label='TEXTO'
                                    value={Datos.TEXTO || ''}
                                    onChange={handleDatos}
                                    variant='outlined'
                                    size='small'
                                    margin='dense'
                                    multiline
                                />
                            </Grid>
                            <Grid item xs={4} md={3} style={{alignSelf:'center'}}>
                                <Grid container justifyContent='center'>
                                    <Grid item>
                                        <TooltipAntd title="SMS" color='pink' >
                                            <SwitchAntd checkedChildren={<CommentOutlinedIcon style={{color:'white', fontSize:16, marginTop:3}}/>} unCheckedChildren={<CommentOutlinedIcon style={{color:'gray', fontSize:16, marginTop:3}}/>} checked={Datos.isSms} onChange={handleSms} />
                                        </TooltipAntd>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item xs={4} md={3} style={{alignSelf:'center'}}>
                                <Grid container justifyContent='center'>
                                    <Grid item>
                                        <TooltipAntd title="MAIL" color='blue' >
                                            <SwitchAntd checkedChildren={<MailOutlinedIcon style={{color:'white', fontSize:16, marginTop:3}}/>} unCheckedChildren={<MailOutlinedIcon style={{color:'gray', fontSize:16, marginTop:3}}/>} checked={Datos.isMail} onChange={handleMail} />
                                        </TooltipAntd>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item xs={4} md={3} style={{alignSelf:'center'}}>
                                <Grid container justifyContent='center'>
                                    <Grid item>
                                        <TooltipAntd title="WHATSAPP" color='green' >
                                            <SwitchAntd checkedChildren={<WhatsAppOutlinedIcon style={{color:'white', fontSize:16, marginTop:3}}/>} unCheckedChildren={<WhatsAppOutlinedIcon style={{color:'gray', fontSize:16, marginTop:3}}/>} checked={Datos.isWhatsapp} onChange={handleWhatsapp} />
                                        </TooltipAntd>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item xs={6} md={4}>
                                    <Button fullWidth size='medium' variant="contained" color='secondary' onClick={handleClear} endIcon={<ClearIcon/>}>
                                        RESETEAR
                                    </Button>
                            </Grid>
                            <Grid item xs={6} md={4}>
                                <TooltipAntd color='lime' title='ENVIAR'>
                                    <span>
                                    <Button fullWidth size='medium' variant="contained" color='primary' endIcon={isProcessing ? <CircularProgress size={20} color='info'/> :  <SendIcon />} onClick={handlePreSend}>
                                        ENVIAR
                                    </Button>
                                    </span>
                                </TooltipAntd>
                            </Grid>
                            
                        </Grid>   
                    </Paper>
                </Grid>
                
            </Grid>
            
        </Fragment>
    );
};


export default withWidth()(Notificaciones);